import React from 'react'
import Fragment from '../common/fragment'


function FragmentBO(props) {
  return (
    <Fragment pos="oo" {...props}>
      <p>
El Convento fue dos veces cárcel (durante el Porfiriato, en tiempos más recientes),
arena de lucha libre, escuela, sede sindical, cuartel de bomberos. Pero nunca ha sido
panal, aunque lo desea.
      </p>
    </Fragment>
  )
}


export default FragmentBO
